// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
    'it-IT': {
        lordgun: {
            facebook: 'https://www.facebook.com/Lordgunbicycles',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'fr-FR': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.France',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'es-ES': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.Spain',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'en-GB': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.UK',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'en-US': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.UK',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'de-DE': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.UK',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
    'en-AU': {
        lordgun: {
            facebook: 'https://www.facebook.com/LordGun.UK',
            instagram: 'https://www.instagram.com/lordgunbicycles',
            strava: 'https://www.strava.com/clubs/lordgun-842524',
            youtube: 'https://youtube.com/c/LordGunBicyclesDotCom',
        },
        runkd: {
            facebook: 'https://www.facebook.com/BeRunkd',
            instagram: 'https://www.instagram.com/runkd_',
            strava: 'https://www.strava.com/clubs/runkd',
            youtube: 'https://www.youtube.com/@runkd5968',
        },
        inwild: {
            facebook: 'https://www.facebook.com/InwildOutdoor',
            instagram: 'https://www.instagram.com/inwild__outdoor',
        },
    },
};
